import Button from "@material-ui/core/Button";
import React from "react";
import { connect } from "react-redux";
import { AVAILABLE_PLAYERS } from "../../../config/players";
import i18n from "../../../i18n";
import './Players.scss';



class Players extends React.Component {

  constructor(props) {
    this.state = {
      players: AVAILABLE_PLAYERS
    }
  }

  handleSubmit = () => {
    this.props.send({ "type": "UPDATE_PLAYERS", players: this.state.players })
  }

  handleChange(e, id) {
    console.log(e, id)
    let newPlayers = [...this.state.players];
    newPlayers[id] = e.target.value
    this.setState({ players: newPlayers });
  }

  render() {

    const { players } = this.state;
    return (
      <div id="players-container">
        <Card>
          <h2 className="header secondary">{"Update Players"}</h2>
          <Input key="player1" value={players[0]} name="Player 1" onChange={(e) => this.handleChange(e, 0)} />
          <Input key="player2" value={players[1]} name="Player 2" onChange={(e) => this.handleChange(e, 1)} />
          <Input key="player3" value={players[2]} name="Player 3" onChange={(e) => this.handleChange(e, 2)} />
          <Input key="player4" value={players[3]} name="Player 4" onChange={(e) => this.handleChange(e, 3)} />
          <Button
            className="login-submit-btn"
            type="submit"
            onClick={() => this.handleSubmit()}
          >
            {i18n.t("BUTTON.UPDATE")}
          </Button>
        </Card>
      </div>
    )
  }
}


const Card = (props) => {
  return (
    <div className="card">
      {props.children}
    </div>
  )
}

const Input = (props) => {
  let formattedName = props.name;
  let id = props.name
    .toLowerCase()
    .split(" ")
    .join("_");

  return (
    <div className="custom-input input">
      <input type="text" id={id} onChange={props.onChange} value={props.value} />
      <label htmlFor={id}>{formattedName}</label>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.scoreboard
  };
};

export default connect(mapStateToProps)(Players);